import { createFileRoute } from '@tanstack/react-router';

import { HourlyTuitionSettings } from '~pages/payments/hourly-tuitions/settings/index';

export const Route = createFileRoute(
  '/_auth/_layout/payment/hourly-tuition/settings',
)({
  component: HourlyTuitionSettings,
});
